<template>
  <AppContainer max-width="max-w-3xl">
    <form
      autocomplete="off"
      @submit.prevent="submitForm"
    >
      <AppCard>
        <TextInput
          v-model="model.key"
          label="Key"
          disabled
          class="disabled:bg-gray-200 disabled:text-gray-800"
        />

        <TextInput
          v-model.trim="formData.values"
          label="Values"
          :class="{ 'input-error': hasValidationError('values') }"
          :validation-error="getValidationError('values') || null"
        />

        <template #buttons>
          <ButtonSubmitRow
            :processing="isSubmitting"
            :cancel-route="{ name: 'app_setting_list' }"
          />
        </template>
      </AppCard>
    </form>
  </AppContainer>
</template>

<script setup>
import { reactive } from 'vue';

import { AppContainer } from '@/components/app';
import { AppCard } from '@/components/cards';
import { ButtonSubmitRow } from '@/components/buttons';
import { TextInput } from '@/components/form-inputs';

import { useFormSubmit } from '@/composables';

const props = defineProps({
  model: {
    type: Object,
    default: () => null,
  },
});

const { isSubmitting, submit, hasValidationError, getValidationError } = useFormSubmit();

const formData = reactive({
  values: props.model?.values || null,
});

const submitForm = async () => {
  await submit(props.model?.id, formData, 'app_setting_list', 'settings');
};

</script>
